import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AnalyticsService } from './shared/services/analytics.service';
import { CommonService } from './shared/services/common.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'ecommerce_order_tracking';
  constructor(private router: Router, private commonService: CommonService, private analyticsServ: AnalyticsService) { }

  trackPortal() {
    this.router.navigate([''])
  }

  redirectToHelpCenter() {
    this.router.navigate([`help-center/${this.commonService.getCookie('order_id')}/${this.commonService.getCookie('request_type')}`]);
  }

  checkForHref() {
    if (this.router.routerState.snapshot.url == "/" || this.router.routerState.snapshot.url.indexOf('Connect') != -1) {
      return true;
    } else {
      return false;
    }
  }
  ngOnInit(): void {
    this.analyticsServ.sendPageLoadTime();
    this.analyticsServ.sendEvent('referrer-' + (document.referrer || 'NA'), {})
  }
}
